import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable, of} from 'rxjs';
import {EntityConfiguracao, EntityConfiguracaoBase} from '~entity/entity-configuracao/entity-configuracao.model';
import {catchError, map} from 'rxjs/operators';
import {ResultMessageVo} from '~model/vo/result-message-vo';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracoesService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = 'configuracao';

  getConfiguracoes(): Observable<EntityConfiguracao> {
    return super.get<EntityConfiguracao>().pipe(this.defaultCatch());
  }

  uploadLogo(arquivo: File): Observable<ResultMessageVo | string> {
    const formData: FormData = new FormData();
    formData.append('imageLogo', arquivo);
    return super.post<{logo: string}>({ extraUrl: 'logo' , objEnvio: formData }).pipe(
      map(res => {
        return res.logo;
      }),
      catchError((err) => {
        const messages: { [k: number]: string } = {
          404: 'Problema ao atualizar logo',
          400: 'Essa operação não foi permitida',
        };
        const erro = {erro: true, message: messages[err.status] || 'Ocorreu um erro inesperado na operação'};
        return of(erro);
      })
    );
  }

  updateConfiguracoes(configuracoes: EntityConfiguracaoBase): Observable<ResultMessageVo> {
    return super.put<EntityConfiguracaoBase>('', {objEnvio: configuracoes}).pipe(
      map(_ => ({message: 'Configurações salvas com sucesso'})),
      catchError((err) => {
        console.log('err', err);
        const messages: { [k: number]: string } = {
          404: 'Problema ao registrar configurações',
          400: 'Essa operação não foi permitida',
          403: 'Você não tem permissão para alterar estas configurações',
        };
        const erro = {erro: true, message: messages[err.status] || 'Ocorreu um erro inesperado na operação'};
        return of(erro);
      })
    );
  }
}
